import { usePostHog } from 'posthog-js/react';
import { FC, Fragment, useEffect } from 'react';

import { Environment } from '../../constants/environments';
import { ImagesApp } from '../../constants/images';
import { useBreadCrumbsContext } from '../../hooks/contexts/breadCrumb.context';
import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import { useUiContext } from '../../hooks/contexts/ui.context';
import { SmallButton } from '../Buttons';
import DiscountsAndPassKey from '../DiscountsAndPassKey';
import ShareEvent from '../ShareEvent';
import * as Styles from './details.styles';
import Summary from './Summary';

const Details: FC = () => {
  const posthog = usePostHog();
  const { loading, event, allTicketsUnavailable } = useEventContext();
  const { isPaymentPage, isTicketPage, isConfirmationPage } = useBreadCrumbsContext();
  const { translate } = useI18nContext();
  const { showModal, setContentModal, toggleModal, defineTitleModal } = useModalContext();
  const { isMobile } = useUiContext();

  const handleOpenModal = () => {
    defineTitleModal(translate(['INFORMATION', 'RELEASE_DISCOUNTS']));
    setContentModal(<DiscountsAndPassKey />);
    toggleModal({ open : !showModal });
    posthog?.capture('purchase:ticket_selection_seediscountarea_click');
  };

  const handleOpenShareModal = () => {
    defineTitleModal(translate(['SHARE_EVENT', 'TITLE']));
    setContentModal(<ShareEvent />);
    toggleModal({ open : !showModal });
  };

  useEffect(() => {
    const header = document.getElementById('header-app');
    if (loading && header) {
      header.style.minHeight = '10px';
      return;
    }
  }, [loading]);

  const showSummaryInDesktop = !isPaymentPage && !allTicketsUnavailable && !isMobile && !isConfirmationPage;
  const eventAddress = [
    event?.place?.name,
    event?.place?.city,
  ].filter(Boolean).join(' | ');

  return (
    <Styles.Details
      $hideContent={isConfirmationPage}
      id="details-container"
      $expand={!allTicketsUnavailable}
    >
      {
        event && (
          <Fragment>
            {isMobile || (
              <Styles.CardImage id="card-image-event">
                <Styles.ImageEvent src={event.poster.medium} alt="event image" id="image-event" />
              </Styles.CardImage>
            )}

            <Styles.DetailsEvent
              id="details-event"
              $expand={!allTicketsUnavailable}
            >
              <Styles.Title id="title-event">{event.title}</Styles.Title>

              <Styles.RowFullWidth id="row-full-width-event-location">
                <Styles.Info id="info-event">
                  <Styles.Icon src={ImagesApp.svg.placeIcon} alt="place icon" id="icon-place" />
                  <Styles.Subtitle id="subtitle-place">
                    {eventAddress}
                  </Styles.Subtitle>
                </Styles.Info>
              </Styles.RowFullWidth>

              <Styles.RowFullWidth id="row-full-width-actions">
                {event.producerId !== 12049153 && (
                  <Styles.Wrapper id="wrapper-actions">
                    <Styles.TextLink id="text-link-event-page" onClick={() => {
                      window.open(`${Environment.INGRESSE_URL}/${event.slug}`, '_blank');
                    }}>
                      {translate(['STEPS', 'TXT18'])}
                    </Styles.TextLink>

                    <Styles.TextLink
                      id="text-link-share"
                      onClick={handleOpenShareModal}
                    >
                      {translate(['STEPS', 'TXT19'])}
                    </Styles.TextLink>

                  </Styles.Wrapper>
                )}

                {isTicketPage && (
                  <Styles.Wrapper id="wrapper-actions-small-button">
                    <SmallButton
                      onClick={handleOpenModal}
                      id='small-button-coupon'
                    >
                      <img src={ImagesApp.svg.icTag} alt="coupon icon" id="icon-coupon" />
                      {translate(['INFORMATION', 'RELEASE_DISCOUNTS'])}
                    </SmallButton>
                  </Styles.Wrapper>
                )}

              </Styles.RowFullWidth>

            </Styles.DetailsEvent>

            {showSummaryInDesktop && <Summary />}

          </Fragment>
        )
      }
    </Styles.Details>
  );
};

export default Details;
